import React from 'react';
import HeroCarousel from '../components/HeroCarousel';
import StoryGrid from '../components/StoryGrid';
import OnChainSnapshot from '../components/OnChainSnapshot';
import NewsletterCTA from '../components/NewsletterCTA';
import Footer from '../components/Footer';
import AdUnit from '../components/AdUnit';
import { useSEO } from '../hooks/useSEO';

interface HomeProps {
  currentPage: string;
  onNavigate: (page: string) => void;
}

const Home: React.FC<HomeProps> = ({ currentPage, onNavigate }) => {
  useSEO({
    title: 'Bitcoin, Macro & AI Intelligence',
    description: 'Daily Bitcoin on-chain analysis, macroeconomic intelligence, and AI disruption signals from UTXOMacro. Facts and some opinions.',
    url: 'https://utxomacro.com',
    keywords: 'Bitcoin, macro economics, on-chain analysis, AI, cryptocurrency, BTC, Federal Reserve, inflation',
  });

  return (
    <div className="min-h-screen" style={{ background: '#0A0A0A' }}>
      <HeroCarousel onNavigate={onNavigate} />
      <OnChainSnapshot />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <AdUnit slot="REPLACE_WITH_SLOT_ID_3" style={{ minHeight: 90 }} />
      </div>
      <StoryGrid onNavigate={onNavigate} />
      <NewsletterCTA />
      <Footer onNavigate={onNavigate} />
    </div>
  );
};

export default Home;
